import { Language } from "./language";

export class Strings {
	private static dictionaries = new Map<Language, Map<string, string>>();
	private static currentLanguage: Language = Language.EN;
	// import.meta.env is Vite-injected; fall back to false when running under
	// plain Node (e.g. scripts/balance-tool.ts via tsx).
	private static warnOnMissing: boolean = (import.meta as { env?: { DEV?: boolean } }).env?.DEV ?? false;

	private constructor() {}

	static registerDictionary(language: Language, entries: Record<string, string>): void {
		let dictionary = Strings.dictionaries.get(language);
		if (!dictionary) {
			dictionary = new Map<string, string>();
			Strings.dictionaries.set(language, dictionary);
		}
		for (const key of Object.keys(entries)) {
			dictionary.set(key, entries[key]);
		}
	}

	static setLanguage(language: Language): void {
		Strings.currentLanguage = language;
	}

	static getLanguage(): Language {
		return Strings.currentLanguage;
	}

	static get(key: string, ...params: unknown[]): string | null {
		const dictionary = Strings.dictionaries.get(Strings.currentLanguage);
		const value = dictionary?.get(key) ?? null;
		if (value === null) {
			if (Strings.warnOnMissing) {
				console.warn(`WARN: No translation for key [${key}] Lang: ${Strings.currentLanguage}`);
			}
			return null;
		}
		if (params.length > 0) {
			return Strings.applyParameters(value, params);
		}
		return value;
	}

	private static applyParameters(str: string, params: unknown[]): string {
		return str.replace(/\$(\d+)/g, (match, digitStr) => {
			const index = parseInt(digitStr, 10) - 1;
			if (index >= params.length) return match;
			return String(params[index]);
		});
	}
}
